import { render, staticRenderFns } from "./DropZone.vue?vue&type=template&id=35363748&scoped=true&"
import script from "./DropZone.vue?vue&type=script&lang=js&"
export * from "./DropZone.vue?vue&type=script&lang=js&"
import style0 from "./DropZone.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DropZone.vue?vue&type=style&index=1&id=35363748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35363748",
  null
  
)

export default component.exports